import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "risa-oasis-ui_v2";
import BadgeWithIcon from "../../../../components/badgeWithIcon/badgeWithIcon";
import ImageviewerModal from "../../../../components/modals/imageViewerModal/imageviewerModal";
import { BusniessOfficeNote } from "../../../../data-model/busniessOfficeNote";
import { Screenshot } from "../../../../data-model/medicalPaOrdersModel";
import { ModalId } from "../../../../enums/modalId";
import {
  closeModal,
  setOpenedModalId,
} from "../../../../redux/slice/modalSlice";
import { AppDispatch, RootState } from "../../../../redux/store/store";
import EyeIcon from "../../../../svg/eye";

interface SingleNotesContainerFOrExternalProps {
  boStatus?: string;
  templateText?: string;
  postScreenshotPath?: string;
}

const BoNotesForExternal = () => {
  const { singleMedicalPaOrder } = useSelector(
    (state: RootState) => state.singleMedicalPaOrder,
  );

  const [busniessOfficeNotes, setBusniessOfficeNotes] = useState<
    BusniessOfficeNote[]
  >([]);
  const [allScreenshots, setAllScreenshots] = useState<Screenshot>({});
  const [dataForUI, setDataForUI] = useState<
    SingleNotesContainerFOrExternalProps[]
  >([]);

  useEffect(() => {
    if (singleMedicalPaOrder) {
      setBusniessOfficeNotes(singleMedicalPaOrder?.auth_on_file?.reports ?? []);
      setAllScreenshots(singleMedicalPaOrder?.auth_on_file?.screenshots ?? {});
    }
  }, [singleMedicalPaOrder]);

  useEffect(() => {
    if (busniessOfficeNotes && allScreenshots) {
      busniessOfficeNotes.forEach((note) => {
        const dataForUI = busniessOfficeNotes.map((note) => {
          const screenshotPathKey = `${note?.report_identifier}_write_back`;
          const screenshotPath =
            allScreenshots?.write_note_cig_box_screenshot?.[
              screenshotPathKey ?? ""
            ];
          return {
            boStatus: note?.report_status ?? "",
            templateText: note?.template_text ?? "",
            postScreenshotPath: screenshotPath ?? "",
          };
        });
        setDataForUI(dataForUI);
      });
    }
  }, [busniessOfficeNotes, allScreenshots]);

  return (
    <div className="all-bo-notes--container mt-2 flex flex-col gap-4">
      {dataForUI.map((item) => (
        <SingleNotesContainerFOrExternal {...item} />
      ))}
    </div>
  );
};

const SingleNotesContainerFOrExternal = (
  props: SingleNotesContainerFOrExternalProps,
) => {
  const dispatch = useDispatch<AppDispatch>();
  const { openedModalId } = useSelector((state: RootState) => state.modal);
  const renderTextWithProperIndentation = (text: string) => {
    const formattedText = (text ?? "N/A").replace(/\\n/g, "\n");
    return (
      <>
        {formattedText.split(/\n{2,}/).map((paragraph, index) => (
          <p key={index} className="mb-4">
            {paragraph.split("\n").map((line, i, arr) => (
              <React.Fragment key={i}>
                {line}
                {i < arr.length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
        ))}
      </>
    );
  };

  useEffect(() => {
    if (openedModalId === ModalId.IMAGE_VIEWER_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_MODAL);
    }
  }, [openedModalId]);

  return (
    <div className="single-note-for-external rounded-lg border border-primaryGray-14 shadow-md">
      <div className="single-note-for-external header flex justify-between border-b border-primaryGray-14 p-3 text-h12">
        <div className="radio-btn--container flex items-center gap-2 text-h12">
          Radio button :{" "}
          <BadgeWithIcon
            text={props.boStatus ?? ""}
            id={"radio-btn"}
            textColor={"#0F0F0F"}
            bgColor={"#F5F5F5"}
          />
        </div>
        {props?.postScreenshotPath !== "" && (
          <div
            className="view-icon flex cursor-pointer items-center gap-1 font-semibold text-tertiaryBlue-4"
            onClick={() => {
              dispatch(
                setOpenedModalId({
                  id: ModalId.IMAGE_VIEWER_MODAL,
                }),
              );
            }}
          >
            {" "}
            <EyeIcon /> View
          </div>
        )}
      </div>
      <div className="single-note-for-external body overflow-auto p-3 text-sm">
        {renderTextWithProperIndentation(props.templateText ?? "")}
      </div>
      {openedModalId === ModalId.IMAGE_VIEWER_MODAL && (
        <ImageviewerModal
          filePaths={[props.postScreenshotPath ?? ""]}
          onClose={() => {
            dispatch(closeModal());
          }}
          fileUrls={[]}
        />
      )}
    </div>
  );
};

export default BoNotesForExternal;
